import * as signalR from '@microsoft/signalr';
import { useOidcStore } from 'vue3-oidc';
import { computed } from 'vue';
import { useStore } from '@/store';
import { MessageActionTypes } from './store/messages/action-types';
import { SegNotificacaoModel } from './models/message/seg-notificacao.model';
import { HubConnectionState } from '@microsoft/signalr';

const { state } = useOidcStore();
const userManager = computed(() => state.value.userManager);
let connection: signalR.HubConnection;

async function init() {
  const user = await userManager.value?.getUser();

  if (user) {
    connection = new signalR.HubConnectionBuilder()
      .withUrl(import.meta.env.VITE_APP_SITE + 'chathub', { transport: signalR.HttpTransportType.LongPolling, accessTokenFactory: () => user?.access_token ?? '', withCredentials: false })
      .configureLogging(signalR.LogLevel.Error)
      .withAutomaticReconnect()
      .build();

    connection.on('receivemessagehandler', (message: SegNotificacaoModel) => {
      userManager.value?.getUser().then((x) => {
        useStore().dispatch(MessageActionTypes.ADD_MESSAGE, { uid: x!.profile.sub, message });
      });
    });

    connection.onclose(async () => {});
    // Start the connection.

    window.onbeforeunload = function () {
      connection.stop();
    };
  }
}

export async function start() {
  try {
    if (!connection) await init();

    if (connection.state == HubConnectionState.Disconnected)
      connection
        .start()
        .then(() => {
          console.log('SignalR Connected.');
        })
        .catch((x) => {
          console.log(x);
          setTimeout(start, 5000);
        });
  } catch (err) {
    console.log(err);
    setTimeout(start, 5000);
  }
}

export function stop() {
  connection.stop();
}
